import { DDDValidator } from 'utils/formatters';
import * as yup from 'yup';

const regexJustLetters = /^([A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]+( [A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]+)*)?$/;

const regexFullName = /^[A-Za-zÁ-ÿ]+(?:\s+[A-Za-zÁ-ÿ]+)+$/;

const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const changePersonalInformationsSchema = yup.object().shape({
  fullName: yup
    .string()
    .required('Informe seu nome completo')
    .trim()
    .matches(regexJustLetters, 'Este campo deve conter somente letras')
    .matches(regexFullName, 'Este campo deve conter o seu nome completo'),
  email: yup
    .string()
    .email('Informe um email válido')
    .required('Informe um email válido')
    .matches(regexEmail, 'Informe um email válido')
    .trim(),
  phoneNumber: yup
    .string()
    .required('Informe o número do seu telefone')
    .matches(/^\(\d{2}\)(?:[2-8]|9[1-9])\d{3}-\d{4}$/, 'Telefone inválido')
    .matches(/^\([1-9]{2}\)/, 'DDD inválido')
    .test('validate if ddd exist', 'DDD inválido', DDDValidator),
});
